// extracted by mini-css-extract-plugin
export default {"switchWrap":"switch_switchWrap__A4AEr","switchChildren":"switch_switchChildren__T-x72","switch":"switch_switch__2Afg7","slider":"switch_slider__GeEGZ","round":"switch_round__EaKqG"};